import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectList } from 'src/app/shared/models/select-list';

@Component({
  selector: 'app-multi-select-dropdown',
  template: `
    <div class="form-group">
      <label class="form-label">{{label | translate}}</label>
      <div class="dropdown-select">
        <div class="dropdown">
          <button class="btn btn-outline-secondary dropdown-toggle w-100" type="button" 
                  [id]="controlName" data-bs-toggle="dropdown" 
                  [attr.aria-expanded]="false">
            {{ getSelectedText() }}
          </button>
          <ul class="dropdown-menu w-100" [attr.aria-labelledby]="controlName">
            <li *ngFor="let option of options">
              <div class="dropdown-item">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" 
                         [id]="option.id" 
                         [checked]="isSelected(option.id)"
                         (change)="toggleSelection(option.id)">
                  <label class="form-check-label" [for]="option.id">
                    {{isArabic ? option.nameAr : option.nameEn}}
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="showError">
        {{'validation.required' | translate}}
      </div>
    </div>
  `,
  styles: [`
    .dropdown-menu {
      max-height: 200px;
      overflow-y: auto;
    }
    .dropdown-item:hover {
      background-color: #f8f9fa;
    }
  `]
})
export class MultiSelectDropdownComponent {
  @Input() label: string = '';
  @Input() options: SelectList[] = [];
  @Input() formGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() isSubmitted: boolean = false;
  @Input() selectedValues: string[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  get isArabic(): boolean {
    return document.documentElement.lang === 'ar';
  }

  get showError(): boolean {
    if (!this.formGroup || !this.controlName) return false;
    const control = this.formGroup.get(this.controlName);
    return this.isSubmitted && control?.errors?.['required'] && control?.touched;
  }

  getSelectedText(): string {
    if (!this.selectedValues?.length) return '';
    
    const selectedItems = this.options.filter(o => this.selectedValues.includes(o.id));
    if (selectedItems.length === 0) return '';
    if (selectedItems.length === 1) return this.isArabic ? selectedItems[0].nameAr : selectedItems[0].nameEn;
    
    return `${selectedItems.length} ${this.isArabic ? 'عناصر محددة' : 'items selected'}`;
  }

  isSelected(id: string): boolean {
    return this.selectedValues?.includes(id) ?? false;
  }

  toggleSelection(id: string): void {
    let newSelection: string[];
    if (this.selectedValues?.includes(id)) {
      newSelection = this.selectedValues.filter(x => x !== id);
    } else {
      newSelection = [...(this.selectedValues || []), id];
    }
    this.selectionChange.emit(newSelection);
    
    if (this.formGroup && this.controlName) {
      this.formGroup.get(this.controlName)?.setValue(newSelection);
    }
  }
}